import React, { useState, useEffect } from 'react'
import './Pagination.scss'
import arrowRight from 'assets/images/arrowRight.svg'
import { useTranslation } from 'react-i18next'
import ReactPaginate from 'react-paginate'

// ii18n
function Pagination(props: any): JSX.Element {
  const [limit, setLimit] = useState(20)
  const [currantPageNumber, setCurrantPageNumber] = useState(1)
  const { t } = useTranslation() // ti18n

  useEffect(() => {}, [])
  const handelRoute = (e: any) => {
    if (e.selected[0] !== '0') {
      props.onPaginationChange({ limit, offset: parseFloat(e.selected) * limit })
      setCurrantPageNumber(parseFloat(e.selected) + 1)
    }
  }

  const handleChange = (value: any) => {
    props.onPaginationChange({ limit: parseFloat(value), offset: 0 })
    setCurrantPageNumber(1)
    setLimit(parseFloat(value))
  }

  return (
    <div>
      {props.totalItems > 0 && (
        <div className="pagination flex flex-wrap ">
          <div className="flex">
            <label
              htmlFor="PaginationSelect"
              className="text-gray-500 text-xs  flex items-center ltr:pr-2 rtl:pl-2">
              {t('No. of rows')}
            </label>
            <select
              id="PaginationSelect"
              value={limit}
              className="pagination-select m-0 p-0"
              onChange={e => handleChange(e.target.value)}>
              <option value="2">2</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>

          <ReactPaginate
            pageCount={Math.ceil(props.totalItems / limit)}
            pageRangeDisplayed={2}
            marginPagesDisplayed={1}
            onPageChange={e => handelRoute(e)}
            breakClassName="mx-1 page-number"
            breakLinkClassName="mx-1 page-number "
            pageClassName="mx-1 page-number "
            activeClassName="mx-1 page-number active"
            activeLinkClassName="mx-1 page-number active"
            nextClassName="mx-1 page-number "
            previousClassName="mx-1 page-number "
            // initialPage={currantPageNumber - 1}
            forcePage={currantPageNumber - 1}
            disableInitialCallback
            pageLinkClassName="mx-1 page-number "
            previousLabel={
              <button
                type="button"
                className="mx-2 arrow   border border-white disabled:opacity-50  disabled:cursor-not-allowed"
                disabled={currantPageNumber === 1}
                onClick={() => {
                  props.onPaginationChange({ limit, offset: (currantPageNumber - 2) * limit })
                  setCurrantPageNumber(currantPageNumber - 1)
                }}>
                <img src={arrowRight} alt="arrowLeft" className="w-[10px] h-[10px] rotate-180" />
              </button>
            }
            nextLabel={
              <button
                type="button"
                className="mx-2 arrow rotate-180 border border-white disabled:opacity-50  disabled:cursor-not-allowed"
                disabled={!(currantPageNumber <= props.totalItems / limit - 1)}
                onClick={() => {
                  props.onPaginationChange({ limit, offset: currantPageNumber * limit })
                  setCurrantPageNumber(currantPageNumber + 1)
                }}>
                <img src={arrowRight} alt="arrowLeft" className="w-[10px] h-[10px] rotate-180" />
              </button>
            }
          />
        </div>
      )}
    </div>
  )
}

export default Pagination
